import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingTourLayout } from 'shared/components/NewbuildingTourLayout';
import { TourFrame } from 'shared/components/TourFrame';
import { TourFrameNotification } from 'shared/components/TourFrameNotification';
import { TourLayout } from 'shared/components/TourLayout';
import { TourSlide } from 'shared/components/TourSlide';
import { selectOfferCategory } from 'shared/selectors';
import { selectTourData } from 'shared/selectors/offerData/tour/selectTourData';

import { track3DTourBlockClick } from './tracking';

export function TourSlideContainer() {
  const { state: isOpen, setTrue: openTour } = useBooleanState();

  const { tourLink, tourBannerImageUrl } = useSelector(selectTourData);

  const offerCategory = useSelector(selectOfferCategory);
  const isNewbuilding = offerCategory === 'newBuildingFlatSale';

  const handleTourShow = React.useCallback(() => {
    openTour();
    track3DTourBlockClick();
  }, [openTour]);

  if (!tourLink || !tourBannerImageUrl) {
    return null;
  }

  return (
    <>
      {!isOpen && (
        <TourSlide>
          {!isNewbuilding && <TourLayout onClick={handleTourShow} tourBannerImageUrl={tourBannerImageUrl} />}
          {isNewbuilding && <NewbuildingTourLayout onClick={handleTourShow} tourBannerImageUrl={tourBannerImageUrl} />}
        </TourSlide>
      )}
      {isOpen && (
        <TourFrameNotification>
          <TourFrame tourUrl={tourLink} />
        </TourFrameNotification>
      )}
    </>
  );
}
